<template>
  <div class="l-block__content">
    <Loading v-if="isLoading" />
    <template v-if="!isLoading">
      <div class="l-block__nav">
        <div
          class="l-block__nav--item"
          @click="changeStep('findTargetPage')"
          :class="{ selected: step === 'findTargetPage' }"
        >
          <span>1.対策ページを見つける</span>
        </div>
        <div
          class="l-block__nav--item"
          @click="changeStep('excuteTask')"
          :class="{ selected: step === 'excuteTask' }"
        >
          <span>2.施策を行う</span>
          <Label v-if="tasksCountRefineContentActive" variant="count">{{
            tasksCountRefineContentActive
          }}</Label>
        </div>
        <div
          class="l-block__nav--item"
          @click="changeStep('observation')"
          :class="{ selected: step === 'observation' }"
        >
          <span>3.施策の効果を見る</span>
          <Label v-if="tasksCountRefineContentDone" variant="count">{{
            tasksCountRefineContentDone
          }}</Label>
        </div>
      </div>

      <template v-if="step === 'excuteTask'">
        <RefineContentExcuteTask
          :project="project"
          :tasks="tasksRefineContentActive"
          :tasksCount="tasksCountRefineContentActive"
          :tasksTodo="tasksRefineContentTodo"
          :tasksCountTodo="tasksCountRefineContentTodo"
          :tasksDoing="tasksRefineContentDoing"
          :tasksCountDoing="tasksCountRefineContentDoing"
          :isLoading="isLoading"
          @completeRefineTask="completeRefineTask"
        />
      </template>

      <template v-if="step === 'observation'">
        <RefineContentObservation
          :project="project"
          :tasks="tasksRefineContentDone"
          :tasksCount="tasksCountRefineContentDone"
          :isLoading="isLoading"
        />
      </template>
      <template v-if="step === 'findTargetPage'">
        <RefineContentFindPage />
      </template>
    </template>
  </div>
</template>

<script>
import Loading from '@/components/Loading';
import Label from '@/components/Label';
import utils from '@/utils';
import RefineContentExcuteTask from '@/components/dashboard/RefineContentExcuteTask';
import RefineContentObservation from '@/components/dashboard/RefineContentObservation';
import RefineContentFindPage from '@/components/dashboard/RefineContentFindPage';

export default {
  props: {
    project: {
      type: Object,
      required: true
    },
    tasks: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      selectedStep: ''
    };
  },

  components: {
    Loading,
    Label,
    RefineContentExcuteTask,
    RefineContentObservation,
    RefineContentFindPage
  },

  computed: {
    tasksRefineContentActive() {
      return this.tasks.filter(v => {
        return v.column === 'todo' || v.column === 'doing';
      });
    },
    tasksCountRefineContentActive() {
      return this.tasksRefineContentActive.length;
    },

    tasksRefineContentTodo() {
      return this.tasks.filter(v => {
        return v.column === 'todo';
      });
    },
    tasksCountRefineContentTodo() {
      return this.tasksRefineContentTodo.length;
    },

    tasksRefineContentDoing() {
      return this.tasks.filter(v => {
        return v.column === 'doing';
      });
    },
    tasksCountRefineContentDoing() {
      return this.tasksRefineContentDoing.length;
    },

    tasksRefineContentDone() {
      return this.tasks.filter(v => {
        //APIのコール数を減らすためにここで処理をしています
        //当日の2ヶ月前から1ヶ月前の間に完了したタスクを取得
        let today = new Date();
        today.setHours(9, 0, 0, 0);

        // demoサイトでは固定のデータを表示させる
        if (process.env.VUE_APP_ENV === 'demo') {
          today = new Date(process.env.VUE_APP_DEMO_DATE);
          today.setHours(9, 0, 0, 0);
        }

        const from = new Date(today);
        from.setMonth(today.getMonth() - 2);
        const to = new Date(today);
        to.setMonth(today.getMonth() - 1);
        const typeDoneDate = new Date(v.typeDoneDate);
        return (
          v.column === 'done' && typeDoneDate >= from && typeDoneDate <= to
        );
      });
    },
    tasksCountRefineContentDone() {
      return this.tasksRefineContentDone.length;
    },
    step() {
      //ユーザーが自分でstepを変更した場合はそちらを優先する
      if (this.selectedStep) return this.selectedStep;

      //初期表示時はタスクの状況によって表示を変える
      if (this.tasksCountRefineContentDone > 0) {
        return 'observation';
      }
      if (this.tasksCountRefineContentActive == 0) {
        return 'findTargetPage';
      } else {
        return 'excuteTask';
      }
    }
  },

  methods: {
    completeRefineTask(task) {
      this.$emit('completeRefineTask', task);
    },
    changeStep(value) {
      this.selectedStep = value;
    }
  }
};
</script>
